import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PlayerService } from '../../character/player.service';
import { GameStateServiceService } from '../../world/GameStateService.service';
import { WantedLevelService } from '../../world/WantedLevelService';
import { WorldService } from '../word-controller/world.service';
import { EscapeService } from '../../world/EscapeService';

@Component({
    selector: 'app-debug',
    templateUrl: './debug.component.html',
    styleUrls: ['./debug.component.css']
})
export class DebugComponent implements OnInit, OnDestroy {
    playerState = '';
    gameState = '';
    wantedLevel = 0;
    anyPursuerHasLoS = false;
    escapeCountdown: number | null = null;

    private destroy$ = new Subject<void>();

    constructor(
        private playerService: PlayerService,
        private gameStateService: GameStateServiceService,
        private wantedLevelService: WantedLevelService,
        public worldService: WorldService,
        private escapeService: EscapeService,
    ) {}

    ngOnInit(): void {
        this.playerService.playerState$
            .pipe(takeUntil(this.destroy$))
            .subscribe(state => this.playerState = state);

        this.gameStateService.gameState$
            .pipe(takeUntil(this.destroy$))
            .subscribe(state => this.gameState = state);

        this.wantedLevelService.wantedLevel$
            .pipe(takeUntil(this.destroy$))
            .subscribe(level => this.wantedLevel = level);

        this.escapeService.anyPursuerHasLoS$
            .pipe(takeUntil(this.destroy$))
            .subscribe(v => this.anyPursuerHasLoS = v);

        this.escapeService.escapeCountdown$
            .pipe(takeUntil(this.destroy$))
            .subscribe(v => this.escapeCountdown = v);
    }

    increaseWantedLevel(): void {
        this.wantedLevelService.increase();
    }

    decreaseWantedLevel(): void {
        this.wantedLevelService.decrease();
    }

    toggleNavmesh(): void {
        this.worldService.toggleNavmeshDebug();
    }

    toggleCollision(): void {
        this.worldService.toggleCollisionDebug();
    }

    toggleRagdoll(): void {
        this.worldService.toggleRagdollDebug();
    }

    toggleRagdollBone(boneName: string): void {
        this.worldService.toggleRagdollBone(boneName);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
